import { cn } from '@shared/lib/utils';
import { ReactNode } from 'react';

interface MetricStackProps {
  className?: string;
  children: ReactNode;
}

export function MetricStack({ className, children }: MetricStackProps) {
  return <div className={cn('flex flex-col gap-4', className)}>{children}</div>;
}
